import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { LLTTFInvitations, LLTTFParticipantEmailVerificationModel } from '../components/invitations/llttf-invitations/llttf-invitations';
import { Observable } from 'rxjs';
import { LLTTFInvitationList, LLTTFInvitationQuery } from '../components/invitations/llttf-invitations/llttf-invitation-list';

@Injectable({
  providedIn: 'root'
})
export class LlttfInvitationService {

  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  getQueryParams(filter: LLTTFInvitationQuery): HttpParams {
      return new HttpParams({ fromObject: filter })
    }

  createllttfinvitation(llttfinvitation:LLTTFInvitations):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    const { id, ...payload } = llttfinvitation;
    return this.http.post(this.apiUrl + 'llttfinvitation/createInvite', payload, { headers:headers});
  }
  
  getAlLLTTFInvitations(queryFilter:LLTTFInvitationQuery):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = this.getQueryParams(queryFilter);
    return this.http.get<LLTTFInvitationList[]>(this.apiUrl+'llttfinvitation/getAllInvitations',{headers:headers,params:params,observe:'response'})
  }

  getLLTTFInvitationDetailsForView(id:string):Observable<any>
  {
     const token = this._authservice.getAuthToken();
     const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
     let params = new HttpParams();
     params = params.append('id',id.toString());
     return this.http.get(this.apiUrl+'llttfinvitation/getInvitationDetailsForView',{headers:headers,params:params})
  }

  getLLTTFInvitationDetailsForUpdate(id:string):Observable<any>
  {
     const token = this._authservice.getAuthToken();
     const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
     let params = new HttpParams();
     params = params.append('id',id.toString());
     return this.http.get(this.apiUrl+'llttfinvitation/getInvitationDetailsForUpdate',{headers:headers,params:params})
  }

  updatellttfinvitation(llttfinvitation:LLTTFInvitations):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post(this.apiUrl + 'llttfinvitation/updateInvite', llttfinvitation, { headers:headers});
  }

  getLLTTFInvitationAuditLogs(id:string):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('id',id.toString());
    return this.http.get(this.apiUrl+'llttfinvitation/getLLTTFAuditLogs',{headers:headers,params:params})
  }

  deleteLLTTFInvitation(id:string):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    let params = new HttpParams();
    params = params.append('id',id.toString());
    return this.http.delete(this.apiUrl+'llttfinvitation/deleteLLTTFInvitation',{headers:headers,params:params})
  }

  accessCohortLink(inviteGuid:string):Observable<any>
  {
    let params = new HttpParams();
    params = params.append('invitationGuid',inviteGuid.toString());
    return this.http.post(this.apiUrl+'llttfinvitation/accessllttfcohort',null,{params:params})
  }

  sendLLTTFVerificationEmail(emailVerificationModel:LLTTFParticipantEmailVerificationModel):Observable<any>
  {
    return this.http.post(this.apiUrl+'llttfinvitation/sendLLTTFVerificationEmail',emailVerificationModel)
  }

  confirmEligibility(verificationGuid:string):Observable<any>
  {
    let params = new HttpParams();
    params = params.append('verificationGuid',verificationGuid.toString());
    return this.http.post(this.apiUrl+'llttfinvitation/confirmEligibility',null,{params:params})
  }

  getEmailFromVerificationGuid(guid:string):Observable<any>
  {
    let params = new HttpParams();
    params = params.append('verificationGuid',guid.toString());
    return this.http.get(this.apiUrl+'llttfinvitation/getEmailFromVerificationGuid',{params:params});
  }

  getPrefilledDataForFacilitator():Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get(this.apiUrl+'llttfinvitation/getPrefilledDataForFacilitator',{headers:headers})
  }
}
